<h2 mat-dialog-title>Dividir Encomenda</h2>
<mat-dialog-content>
  <div class="split-order-content">
    <div class="input-section">
      <p>Escolha o número de entregas:</p>
      <mat-form-field>
        <input
          matInput
          type="number"
          [(ngModel)]="entregas"
          [min]="1"
          [max]="data.entregas"
          [disabled]="isEntregasDefinedByRules"
          (ngModelChange)="onEntregasChange()"
          [matTooltip]="isEntregasDefinedByRules ? 'Número de entregas definido por regras' : ''"
          />
          @if (entregas > data.entregas) {
            <mat-error>
              Máximo de {{ data.entregas }} entregas
            </mat-error>
          }
          @if (entregas < 1) {
            <mat-error> Mínimo de 1 entrega </mat-error>
          }
        </mat-form-field>

        <!-- Add helper text to show how many months need to be selected -->
        @if (entregas > 0) {
          <div class="selection-hint">
            {{ getRemainingSelectionsText() }}
          </div>
        }
      </div>

      <div class="calendar-section">
        <div class="months-grid">
          @for (month of months; track month) {
            <div
              class="month-cell"
              [class.has-delivery]="month.hasDelivery"
              [class.is-selected]="month.isSelected"
              [class.disabled]="month.disabled"
              [class.rule-suggested]="month.isRuleDefined"
              (click)="onMonthClick(month)"
              [class.clickable]="!month.disabled"
              [matTooltip]="month.isRuleDefined ? 'Sugerido por regra (pode alterar)' : ''"
              >
              <div class="month-name">{{ month.month.toUpperCase() }}</div>
              <div class="year">{{ month.year }}</div>
              <div class="delivery-number">
                {{
                month.hasDelivery ? "Entrega " + month.deliveryNumber : "\u00A0"
                }}
              </div>
              @if (month.isRuleDefined) {
                <div class="rule-indicator">
                  <mat-icon class="rule-icon" fontSet="material-icons">lightbulb</mat-icon>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancelar</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!isFormValid()"
      >
      Confirmar
    </button>
  </mat-dialog-actions>
